<template>
  <div class="ql-editor" v-html="content"></div>
</template>

<script>
export default {
  name: 'Reader',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.ql-editor {
  height: initial;

  /deep/ h1 {
    font-size: 2em !important;
  }

  /deep/ h2 {
    font-size: 1.5em !important;
  }

  /deep/ h3 {
    font-size: 1.17em !important;
  }

  /deep/ h4 {
    font-size: 1em !important;
  }

  /deep/ h5 {
    font-size: 0.83em !important;
  }
  /deep/ h6 {
    font-size: 0.67em !important;
  }

  /deep/ hr {
    background: $primary;
  }
}
</style>
